import { Injectable } from '@angular/core';
import {FileApiClass} from '../../api/File/file.api.class';
import {Observable} from 'rxjs';
import {File} from '../../interfaces/File/File';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private fileApiClass: FileApiClass) { }

  public writeFile(file): Observable<any> {
    return this.fileApiClass.writeFile(file);
  }
}
